/* -----------------------------------------------------------
   styling-lab.js
   楽天GOLD contents/styling-lab/ の jQuery 依存を素のJSに置き換えたもの。
   元のページは jQuery / Bootstrap JS / smooth-scroll / lazyload を
   読み込んでいたが、本店では外部ライブラリを足したくないので自前で書く。

   対象は .slab-top / .slab-online の中だけ。テーマ側には触らない。
   ----------------------------------------------------------- */
(function () {
  'use strict';

  function roots() {
    return Array.prototype.slice.call(
      document.querySelectorAll('.slab-top, .slab-online')
    );
  }

  /* --- スライドトグル（jQueryの slideToggle 相当） --------------- */
  function slideDown(el, ms) {
    el.style.overflow = 'hidden';
    el.style.display = 'block';
    var h = el.scrollHeight;
    el.style.height = '0px';
    el.style.transition = 'height ' + ms + 'ms ease';
    /* 強制リフロー。これが無いと transition が走らない */
    void el.offsetHeight;
    el.style.height = h + 'px';
    window.setTimeout(function () {
      el.style.height = '';
      el.style.overflow = '';
      el.style.transition = '';
    }, ms);
  }

  function slideUp(el, ms) {
    el.style.overflow = 'hidden';
    el.style.height = el.scrollHeight + 'px';
    el.style.transition = 'height ' + ms + 'ms ease';
    void el.offsetHeight;
    el.style.height = '0px';
    window.setTimeout(function () {
      el.style.display = 'none';
      el.style.height = '';
      el.style.overflow = '';
      el.style.transition = '';
    }, ms);
  }

  function isOpen(el) {
    return window.getComputedStyle(el).display !== 'none';
  }

  function slideToggle(el, ms) {
    if (isOpen(el)) { slideUp(el, ms); } else { slideDown(el, ms); }
  }

  /* --- ハンバーガー（.openbtn1 → #g-nav） ------------------------ */
  function bindHamburger(root) {
    var btn = root.querySelector('.openbtn1');
    var nav = root.querySelector('#g-nav');
    if (!btn || !nav) { return; }
    btn.addEventListener('click', function () {
      btn.classList.toggle('active');
      nav.classList.toggle('panelactive');
    });
    /* ナビ内のリンクを踏んだら閉じる */
    Array.prototype.forEach.call(nav.querySelectorAll('a'), function (a) {
      a.addEventListener('click', function () {
        btn.classList.remove('active');
        nav.classList.remove('panelactive');
      });
    });
  }

  /* --- ヘッダー追従（スクロールで #header に .fixed） -------------- */
  function bindFixedHeader(root) {
    var header = root.querySelector('#header');
    if (!header) { return; }
    var h = header.offsetHeight;
    function update() {
      if (window.pageYOffset >= h) {
        header.classList.add('fixed');
      } else {
        header.classList.remove('fixed');
      }
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', function () { h = header.offsetHeight; update(); });
    update();
  }

  /* --- アコーディオン（.accordion-wrap） -------------------------- */
  function bindAccordionWrap(root) {
    var wraps = root.querySelectorAll('.accordion-wrap');
    Array.prototype.forEach.call(wraps, function (wrap) {
      wrap.addEventListener('click', function () {
        var kids = wrap.children;
        var head = kids[0];
        var text = kids[1];
        if (!text) { return; }
        /* 他のアコーディオンは閉じる */
        Array.prototype.forEach.call(wraps, function (other) {
          if (other === wrap) { return; }
          var otherText = other.children[1];
          if (otherText && isOpen(otherText)) { slideUp(otherText, 300); }
          var otherIcon = other.querySelector('.accordion-header i');
          if (otherIcon) { otherIcon.classList.remove('rotate-fa'); }
        });
        slideToggle(text, 300);
        if (head) { head.classList.toggle('accordion-no-bar'); }
        var icon = wrap.querySelector('.fa');
        if (icon) { icon.classList.toggle('rotate-fa'); }
      });
    });
  }

  /* --- アコーディオン（.accordion_title → .accordion_inner） ------- */
  function bindAccordionTitle(root) {
    Array.prototype.forEach.call(
      root.querySelectorAll('.accordion_title'),
      function (title) {
        title.addEventListener('click', function () {
          var inner = title.nextElementSibling;
          if (inner && inner.classList.contains('accordion_inner')) {
            slideToggle(inner, 300);
          }
          title.classList.toggle('open');
        });
      }
    );
  }

  /* --- スクロールで出るフェードイン（.fadein → .scrollin） --------- */
  function bindFadeIn(root) {
    var items = root.querySelectorAll('.fadein');
    if (!items.length) { return; }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('scrollin');
            io.unobserve(e.target);
          }
        });
      }, { rootMargin: '0px 0px -150px 0px' });
      Array.prototype.forEach.call(items, function (el) { io.observe(el); });
    } else {
      Array.prototype.forEach.call(items, function (el) { el.classList.add('scrollin'); });
    }
  }

  /* --- トップへ戻る（#page-top） ---------------------------------- */
  function bindPageTop(root) {
    var btn = root.querySelector('#page-top');
    if (!btn) { return; }
    function update() {
      if (window.pageYOffset > 500) {
        btn.classList.add('is-visible');
      } else {
        btn.classList.remove('is-visible');
      }
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* --- ページ内アンカーのスムーススクロール ------------------------ */
  function bindSmoothAnchors(root) {
    Array.prototype.forEach.call(root.querySelectorAll('a[href^="#"]'), function (a) {
      var id = a.getAttribute('href');
      if (!id || id === '#') { return; }
      a.addEventListener('click', function (e) {
        var target = root.querySelector(id) || document.querySelector(id);
        if (!target) { return; }
        e.preventDefault();
        var y = target.getBoundingClientRect().top + window.pageYOffset - 50;
        window.scrollTo({ top: y, behavior: 'smooth' });
      });
    });
  }

  function init() {
    roots().forEach(function (root) {
      bindHamburger(root);
      bindFixedHeader(root);
      bindAccordionWrap(root);
      bindAccordionTitle(root);
      bindFadeIn(root);
      bindPageTop(root);
      bindSmoothAnchors(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
